import { useQuery } from '@tanstack/react-query'
import { transferServices } from '../transferServices'
import {
  OnRampCryptoPriceQuotesDTO,
  AdaptedOnRampCryptoPriceQuotesDTO,
} from '../transferTypes'

interface QueryOptions {
  enabled?: boolean
}

/**
 * useCalcOnRampCryptoPriceQuotes
 *
 * Request to get crypto price quotes for a crypto/fiat pair.
 *
 * **API:** POST `/v1/transfer/on-ramp/crypto-price-quotes`
 */
export const useCalcOnRampCryptoPriceQuotes = (
  payload: OnRampCryptoPriceQuotesDTO,
  options?: QueryOptions,
) => {
  const optionsEnabled = options !== undefined ? options.enabled : true

  return useQuery<AdaptedOnRampCryptoPriceQuotesDTO>({
    queryKey: ['ON_RAMP_CRYPTO_PRICE_QUOTES', payload],
    queryFn: () => transferServices.getCryptoPriceQuotesByCurrency(payload),
    enabled:
      optionsEnabled &&
      payload.cryptoCurrency?.length >= 1 &&
      payload.fiatCurrency?.length >= 1 &&
      payload.amount > 0,
    staleTime: 1000 * 30, // 30 seconds
    retry: false,
  })
}
